// AUTO GENERATED FILE - Changes WILL be lost.
// uk - used as 'uk' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Ігровий купон",
  "product.last60-row-single": "Останній 60-та односетсетний матч НБА",
  "product.sb-english-single": "Англійський футболбет один матч",
  "product.sb-italian-single": "Італійський футболбет один матч",
  "product.sb-greek-single": "Грецький Soccerbet один матч",
  "product.sb-english-league": "Англійська футбольна ліга",
  "product.sb-italian-league": "Італійська футбольна ліга",
  "product.sb-greek-league": "Грецька футбольна ліга",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Зробити ставку",
  "betslip.clear": "Очистити всі",
  "betslip.clearResult": "Очистити",
  "betslip.noSelections": "Оберіть події для розміщення ставки",
  "betslip.notLoggedIn": "Увійдіть щоб зробити ставку",
  "betslip.refresh": "Оновити",
  "betslip.totalStake": "Сума",
  "betslip.noHistoryData": "Немає інформації за ставками",
  "betslip.openBets": "Відкриті ставки",
  "betslip.betHistory": "Історія ставок",
  "betslip.betHistoryWon": "Виграш",
  "betslip.betHistoryLost": "Програш",
  "loading.loading": "Завантаження",
  "loading.account": "Завантаження аккаунта",
  "loading.league": "Завантаження ліги",
  "loading.gameweeks": "Завантаження ігрового тижня",
  "loading.markets": "Завантаження подій",
  "loading.bethistory": "Завантаження історії ставок",
  "login.loginRequired": "Потрібен логін",
  "login.loginToBet": "Будь ласка, увійдіть щоб зробити ставку",
  "navigation.back": "Повернутися",
  "navigation.close": "Закрити",
  "video.liveStreamAvailable": "Live трансляція доступна",
  "video.logInToWatch": "Будь ласка, авторизуйтесь для перегляду",
  "error.error": "Помилка",
  "error.404": "Сторінку не знайдено",
  "error.gameLaunchFailed": "Неможливо запустити гру",
  "error.unknownErrorCode": "Невідома помилка: {code}",
  "error.minUnitStakeLimitExceeded": "Мінімальна ставка {limit}",
  "error.maxUnitStakeLimitExceeded": "Максимальна ставка {limit}",
  "error.minTotalStakeLimitExceeded": "Мінімальна сума ставки {limit}",
  "error.maxTotalStakeLimitExceeded": "Максимальна сума ставки {limit}",
  "error.stakeInvalidMultiple": "Кол має бути кратним {multiple}",
  "error.notPlaced": "Ставка не розміщена",
  "error.wagerDisallowed": "Ставка заборонена",
  "error.errorEventIsOff": "Подія розпочалася",
  "wagerType.Singles": "Ординар",
  "wagerType.Doubles": "Двійники",
  "wagerType.Trebles": "Трійники",
  "wagerType.Accumulator": "Експрес",
  "wagerType.Perm 4-Folds": "Система 4",
  "wagerType.Perm 5-Folds": "Система 5",
  "wagerType.Perm 6-Folds": "Система 6",
  "wagerType.Perm 7-Folds": "Система 7",
  "wagerType.Perm 8-Folds": "Система 8",
  "wagerType.Perm 9-Folds": "Система 9",
  "error.excess_bets": "Максимум одночасних ставок {limit} на ставках; будь ласка, зніміть ставку",
  "product.sb-turkish-league": "Турецька футбольна ліга",
  "error.minBetslipLimitExceeded": "Мінімальна загальна ставка ставки становить {limit}",
  "error.maxBetslipLimitExceeded": "Максимальна загальна ставка становить {limit}",
  "error.exceededMaxPayout": "Максимальна потенційна виплата становить {limit}; Будь ласка, зменшіть свою ставку.",
  "betslip.potentialReturns": "Потенційна віддача",
  "betslip.taxDisclaimer": "Всі ваші чисті виграші оподатковуються при розрахунку ставок. Сума податку буде розраховуватися в залежності від потенційного виграшу ставки.",
  "error.maintenanceEnabled": "Сервер в даний час проходить технічне обслуговування",
  "error.internalError": "Внутрішня помилка",
  "error.invalidSession": "Сесія недійсна",
  "error.accountDisabled": "Обліковий запис вимкнено",
  "error.invalidPlayerID": "Неправильний ідентифікатор гравця",
  "error.insufficientBalance": "Недостатній баланс",
  "error.configError": "Помилка конфігурації",
  "error.betPlaceFailed": "Не вдалося зробити ставку",
  "error.invalidProductID": "Невірний ідентифікатор товару",
  "error.playerReachedGamingLimits": "Гравець досягнув відповідальних ігрових лімітів",
  "error.gameCycleDoesNotExist": "Ігрового циклу не існує",
  "error.betAmountLimitExceeded": "Перевищення ліміту потенційного виграшу для неперевірених гравців",
  "betslip.netStake": "Чистий пакет акцій",
  "betslip.tax": "Податок",
  "error.badReturns": "Потенційна прибутковість нижча, ніж валовий пакет акцій",
  "betslip.taxDisclaimerPoland": "Виграш буде зменшено на 10%, якщо сума перевищує 2 280 злотих.",
  "error.incompatibleVersion": "Непідтримувана версія програми. Будь ласка, оновіть її.",
  "product.iihf-row-single": "Чемпіонат світу з хокею з шайбою",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Повернутись до програвача",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "Середній показник RTP у цій грі становить {limit}",
  "error.betslipContainsInvalidOptions": "Бетсліп містить недійсні варіанти червоним кольором",
  "sb-english.team.ARS": "Арсенал",
  "sb-english.team.AST": "Астон В.",
  "sb-english.team.BHA": "Брайтон",
  "sb-english.team.BOU": "Борнмут",
  "sb-english.team.BUR": "Бернлі",
  "sb-english.team.CHE": "Челсі",
  "sb-english.team.CRY": "Крістал Пелес",
  "sb-english.team.EVE": "Евертон",
  "sb-english.team.LEI": "Лестер",
  "sb-english.team.LIV": "Ліверпуль",
  "sb-english.team.MNC": "Манчестер С.",
  "sb-english.team.MNU": "Манчестер Ю.",
  "sb-english.team.NEW": "Ньюкасл",
  "sb-english.team.SOU": "Саутгемптон",
  "sb-english.team.TOT": "Тотенхем",
  "sb-english.team.WAT": "Вотфорд",
  "sb-english.team.WHU": "Вест Гем",
  "sb-english.team.WOL": "Вульвс",
  "sb-english.team.NOR": "Норвіч",
  "sb-english.team.SHU": "Шеффілд Ю.",
  "sb-english.team.LEE": "Лідс",
  "sb-english.team.FUL": "Фулхем",
  "sb-english.team.WBA": "Вест Бром",
  "nomorebets": "Прийняття ставок закрито",
  "playtime": "Час гри",
  "gameId": "ID гри",
  "noGames": "В даний момент немає доступних ігр. Будь ласка, спробуйте ще раз пізніше.",
  "Home": "Господарі",
  "Away": "Гості",
  "Visitor": "Відвідувачі",
  "soccerbet.gameWeek": "СЕЗОН",
  "soccerbet.noGameWeeks": "Немає доступних сезонів. Спробуйте ще раз найближчим часом.",
  "soccerbet.league": "Таблиця ліги",
  "soccerbet.table.name": "Команда",
  "soccerbet.table.won": "В",
  "soccerbet.table.drawn": "Н",
  "soccerbet.table.lost": "П",
  "soccerbet.table.points": "Очки",
  "abbr.event.Both Teams To Score": "ОЗ",
  "event.Both Teams To Score": "Обидві Команди Заб'ють",
  "event.Over / Under": "Більше/Менше",
  "event.Double Chance": "Подвійний Результат",
  "event.Match Result": "Результат Матчу",
  "event.Exact Goals": "Кількість Голів",
  "event.Correct Score": "Точний Рахунок",
  "event.Match Result Both Score": "Результат Матчу + Обидві Заб'ють",
  "event.Result Und/Over 1.5 Total Goals": "Результат Матчу + Тотал Більше/Менше 1.5",
  "event.Result Und/Over 2.5 Total Goals": "Результат Матчу + Тотал Більше/Менше 2.5",
  "event.Under Over 1.5 Total Goals": "Тотал Більше/Менше 1.5 голів",
  "event.Under Over 2.5 Total Goals": "Тотал Більше/Менше 2.5 голів",
  "event.Under Over 3.5 Total Goals": "Тотал Більше/Менше 3.5 голів",
  "event.Under Over 4.5 Total Goals": "Тотал Більше/Менше 4.5 голів",
  "event.Total Goals 1 To 2": "Тотал від 1 до 2 голів",
  "event.Total Goals 1 To 3": "Тотал від 1 до 3 голів",
  "event.Total Goals 1 To 4": "Тотал від 1 до 4 голів",
  "event.Total Goals 2 To 3": "Тотал від 2 до 3 голів",
  "event.Total Goals 2 To 4": "Тотал від 2 до 4 голів",
  "event.Under Over 1.5 Home Goals": "Господарі Тотал Більше/Менше 1.5 голів",
  "event.Under Over 1.5 Away Goals": "Гості Тотал Більше/Менше1.5 голів",
  "event.Home Team Exact Goals": "Господарі Кількість Голів",
  "event.Away Team Exact Goals": "Гості Кількість Голів",
  "selection.Yes": "Так",
  "selection.No": "Ні",
  "selection.1+G": "П1+Так",
  "selection.1+Ng": "П1+Ні",
  "selection.X+G": "Х+Так",
  "selection.X+Ng": "Х+Ні",
  "selection.2+G": "П2+Так",
  "selection.2+Ng": "П2+Ні",
  "selection.1+Yes": "1+Так",
  "selection.1+No": "1+Ні",
  "selection.X+Yes": "Х+Так",
  "selection.X+No": "Х+Ні",
  "selection.2+Yes": "2+Так",
  "selection.2+No": "2+Ні",
  "selection.TID_ANY_GOAL_SCORED_YES": "Г",
  "selection.TID_ANY_GOAL_SCORED_NO": "Нг",
  "selection.U": "М",
  "selection.O": "Б",
  "selection.1+O": "П1+Б",
  "selection.X+O": "Х+Б",
  "selection.2+O": "П2+Б",
  "selection.1+U": "П1+М",
  "selection.X+U": "Х+М",
  "selection.2+U": "П2+М",
  "selection.TID_HOME_WIN": "П1",
  "selection.TID_AWAY_WIN": "П2",
  "selection.TID_DRAW": "Х",
  "selection.TID_HOME_WIN_OR_DRAW": "П1/Х",
  "selection.TID_DRAW_OR_AWAY_WIN": "П2/Х",
  "selection.TID_HOME_OR_AWAY_WIN": "П1/П2",
  "sb-english.team.BRE": "Брентфорд",
  "abbr.sb-english.team.BRE": "БРЕ"
}
